<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="pl-3">
          <router-link to="/">
            <img src="@/assets/images/fashionphile.svg" alt height="30" />
          </router-link>
        </div>
      </div>
      <div class="d-flex">
        <div class="dropdown b-dropdown btn-group" v-if="stylist && notifications" @click="openModal('notifications')">
          <button type="button" class="btn dropdown-toggle btn-black header-item noti-icon" >
            <i :class="notificationIconClass"></i>
            <span v-if="unreadNotificationsCount" class="badge badge-danger badge-pill">{{ unreadNotificationsCount }}</span>
          </button>
        </div>
        <b-modal
          id="notifications-modal"
          header-class="d-none"
          footer-class="d-none"
          static
        >
          <notifications @unreadNotifications="updateUnreadNotificationCount"></notifications>
        </b-modal>
        <div v-if="stylist" class="dropdown d-inline-block">
          <button type="button" class="btn header-item" @click="openModal('profile')">
            <img v-if='stylist.thumbnailUrl' class='rounded-circle avatar-xs' :src='`${stylist.thumbnailUrl}`' />
            <div v-else class='avatar-sm mb-4'>
              <span class='avatar-title rounded-circle bg-soft-primary text-primary font-size-16 upload'>
                {{ stylist.initials }}
              </span>
            </div>
          </button>
        </div>
        <b-modal
          id="profile-modal"
          header-class="d-none"
          footer-class="d-none"
        >
          <profile></profile>
        </b-modal>
      </div>
    </div>
  </header>
</template>
<style>
  #profile-modal .btn {
    width: 100%;
  }
</style>

<script>
import Profile from '@/components/profile'

export default {
  components: {
    Profile,
    Notifications: () => import('@/components/notifications')
  },
  data () {
    return {
      notifications: true,
      unreadNotificationsCount: '',
      notificationIconClass: 'bx bx-bell'
    }
  },
  computed: {
    stylist () {
      return this.$store.state.stylist
    }
  },
  methods: {
    updateUnreadNotificationCount (count) {
      this.unreadNotificationsCount = count
      if (count > 0) {
        this.notificationIconClass = 'bx bx-bell bx-tada'
        setTimeout(function (scope) {
          scope.notificationIconClass = 'bx bx-bell'
        }, 4000, this)
      }
    },
    openModal (modal) {
      this.$bvModal.show(modal + '-modal')
    }
  }
}
</script>
